import { observer } from 'mobx-react-lite';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import { BRollFrameThumbnails } from './BRollFrameThumbnails';
import { VolumeKeyPoints } from './VolumeKeyPoints';

import type { ElementState } from '../../renderer/ElementState';

type TimelineBrollElementProps = {
  element: ElementState;
  thumbnail: string;
  elementWidth: number;
  height: number;
};

const TimelineBrollElement: React.FC<TimelineBrollElementProps> = observer(
  props => {
    const [height, setHeight] = useState(0);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
      if (ref.current === null) return;
      setHeight(ref.current?.clientHeight);
    });

    const { element, thumbnail, elementWidth, height: containerHeight } = props;

    return (
      <Fragment>
        <Container ref={ref}>
          <BRollFrameThumbnails
            videoUrl={element.source.source}
            trimStart={element.trimStart || 0}
            duration={element.duration}
            elementWidth={elementWidth}
            height={containerHeight}
            fallbackThumbnailUrl={thumbnail}
          />
          <VolumeKeyPoints
            id={element.source.id}
            element={element}
            type={element.source.type}
            height={height}
          />
        </Container>
      </Fragment>
    );
  },
);

export default TimelineBrollElement;
const Container = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
`;
